// DEPENDENCIES
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { isMobile } from '../../utils';
import SVGInline from "react-svg-inline"
import { BAND, MUSICIAN, SERVICE, LIVE_MUSIC } from '../../consts';

// components

// svg icons
import locationSVG from '../inlineSVGs/locationSVG';
import sleepingMugicsSVG from '../inlineSVGs/sleepingMugicsSVG';
import scopWhiteSVG from '../inlineSVGs/scopWhiteSVG';
import smallStarSVG from '../inlineSVGs/smallStarSVG';
import trashSVG from '../inlineSVGs/trashSVG';
import bounceSVG from '../inlineSVGs/bounceSVG';
import editSVG from '../inlineSVGs/editSVG';


// styles
import './PinsList.css';
import {ENROL_TYPE_FREE, ENROL_TYPE_HIGH, ENROL_TYPE_HUGE, ENROL_TYPE_MEDIUM} from "../../Models/consts";

// icons
import lightningSlickSVG from "../inlineSVGs/lightningSlickSVG";
import shineSharpSVG from "../inlineSVGs/shineSharpSVG";
import trophySVG from "../inlineSVGs/trophySVG";
import { CheckboxRound } from "../Elements/Inputs/";

const PinsList = ({
                      type,
                      pins,
                      editPin,
                      removePin,
                      newPin,
                      bouncePin,
                      datatypes,
                      selectEnroll,
                      handleHeroAdToggle
}) => {
    const getCategoriesImage = (pin) => {
        if (!datatypes) return null;
        const cat = datatypes.categories[pin.type].filter(c => c.name === pin.category);

        if (type.name === LIVE_MUSIC || type.name === SERVICE) {
            return cat && cat[0] && cat[0].images && cat[0].images[2].src
        }

        return null
    };

    const renderStatus = (pin) => {
        if (pin.isOnHold) {
            return (
                <div className="pin-status">
                    {/*<i><FaPause/></i>*/}
                    <div className="dot yellow" />
                    <div className="status-text-wrapper">
                        <p>ממתין </p>
                        <p>לאישור</p>
                    </div>
                </div>
            )
        }

        if (pin.subscription && pin.subscription.temp) {
            return (
                <div className="pin-status">
                    {/*<i><FaPause/></i>*/}
                    <div className="dot yellow" />
                    <div className="status-text-wrapper">
                        <p>מושהה</p>
                    </div>
                </div>
            )
        }

        if (!pin.isUserVerified) {
            return (
                <div className="pin-status">
                    {/*<i><FaPause/></i>*/}
                    <div className="dot yellow" />
                    <div className="status-text-wrapper">
                        <p>נדרש אישור מייל</p>
                    </div>
                </div>
            )
        }

        if (pin.type === LIVE_MUSIC && pin.date && !moment(pin.date).add(1, 'day').isAfter(moment())) {
            return (
                <div className="pin-status">
                    {/*<i><FaPause/></i>*/}
                    <div className="dot yellow" />
                    <div className="status-text-wrapper">
                        <p>תאריך חלף</p>
                    </div>
                </div>
            )
        }

        if (
            pin.subscription && pin.subscription.enrolType !== 'free' &&
            moment(pin.subscription.lastPayed).toDate() < moment().subtract(1, 'month').subtract(1, 'day').toDate()
        ) {
            return (
                <div className="pin-status">
                    {/*<i><FaPause/></i>*/}
                    <div className="dot red" />
                    <p>נדרש תשלום</p>
                </div>
            )
        }

        return (
            <div className="pin-status">
                {/*<i><FaPlay/></i>*/}
                <div className="dot green" />
                <p>באויר</p>
            </div>
        )
    };

    const renderHeroSelection = (pin, enrolType) => {

        const isActive = enrolType === ENROL_TYPE_HUGE;

        const trophyColor = isActive ? '#8021fc' : '#888888';

        return (
            <div className="hero-selection-container">
                <CheckboxRound
                    isChecked={isActive}
                    onToggle={() => handleHeroAdToggle(pin._id)}
                />
                <label className={`hero-label ${isActive ? 'active' : ''}`}>Hero Ad</label>
                <SVGInline className="icon-trophy" svg={trophySVG(trophyColor, trophyColor)} component="i" />
            </div>
        )
    }

    const renderUpgradeBtn = (pin, enrolType) => {
        return (
            <div className="upgrade-btn" onClick={() => selectEnroll()}>
                <SVGInline className="icon-shine" svg={shineSharpSVG()} component="i" />
                <label className="upgrade-btn-txt">
                    {enrolType === ENROL_TYPE_FREE ? 'שדרג חבילה' : 'עדכן חבילה'}
                </label>
            </div>
        )
    }

    const renderArrow = pin => {
        if (isMobile() || pin.subscription.temp) return null;

        const enrolType = pin.subscription.upgrade || pin.subscription.enrolType;

        if (enrolType === ENROL_TYPE_FREE) {
            return (
                <div className={`arrow ${enrolType}`} >
                    <div className="triangle"></div>
                    <label>מודעה בסיסית</label>
                </div>
            )
        }

        if (enrolType === ENROL_TYPE_MEDIUM) {
            return (
                <div className={`arrow ${enrolType}`} >
                    <div className="triangle"></div>
                    <label>מודעת Push</label>
                </div>
            )
        }

        if (enrolType === ENROL_TYPE_HIGH) {
            return (
                <div className={`arrow ${enrolType}`} >
                    <div className="triangle"></div>
                    <label>מודעת Rule</label>
                </div>
            )
        }

        if (enrolType === ENROL_TYPE_HUGE) {
            return (
                <div className={`arrow ${enrolType}`} >
                    <div className="triangle"></div>
                    <div className="huge-label-container">
                        <SVGInline className="icon-huge-lightning" svg={lightningSlickSVG} component="i" />
                        <label>מודעת Hero</label>
                        <SVGInline className="icon-huge-lightning" svg={lightningSlickSVG} component="i" />
                    </div>
                </div>
            )
        }
    };

    const renderLocation = location =>  {
        let locationString = location.street && location.street.length > 13 ? location.street.substring(0, 13) + '...' : location.street;
        if (!window.locationString && location.city) {
            locationString = location.city.length > 13 ? location.city.substring(0, 13) + '...' : location.city
        }

        return locationString
    };

    const renderSubLocation = location => {
        if (!location) return '';

        if (location.revenueName) return location.revenueName;

        if (!location.street) return '';

        return `${location.street}, ${location.number || ''}`
    }

    // const renderDatePassedLabel = pin => {
    //     if (!pin || !pin.date) return null;
    //
    //     if (moment(pin.date).isAfter(moment())) return null;
    //
    //     return (
    //         <div className="label-date-passed-wrapper">
    //             <p className="label-date-passed">{'Date Passed'}</p>
    //         </div>
    //     )
    // };

    const renderPinRowWeb = pins => {
        if (!pins || !pins.length) return null;

        return pins.map((pin,index) => {
            if (!pin || !pin.subscription) return null;

            const enrolType = pin.subscription.upgrade || pin.subscription.enrolType;

            return (
                <div className="pin-row" key={type.name + index}>
                    <div className="leftBox rtl">
                        <div className="content">
                            <div className={`inner-left ${type.name}`}>
                                <div className="icon" style={{backgroundImage: 'url(' + getCategoriesImage(pin) + ')' }}>
                                    {type.name === BAND || type.name === MUSICIAN
                                        ?
                                        <SVGInline svg={smallStarSVG} component="i" className="small-start"/>
                                        : null
                                    }
                                </div>
                                <div className="pin-name">{pin.name.length > titleLetters ? pin.name.substring(0, 13) + '...' : pin.name}</div>
                            </div>
                            <div className="location-status-container">
                                <div className="location-container">
                                    <SVGInline svg={locationSVG()} component="i" width="21px" height="21px" className="locationIcon"/>
                                    <div className="location">{renderLocation(pin.location)}</div>
                                    {/*<div className="location-sub-title">{renderSubLocation(pin.location)}</div>*/}
                                </div>
                                {renderStatus(pin)}
                            </div>
                        </div>

                    </div>
                    <div className="rightBox rtl">
                        <div className="content">
                            <div className="options">
                                <SVGInline
                                    onClick={()=>editPin(pin)}
                                    svg={editSVG}
                                    component="i"
                                    className="edit tooltip-md"
                                    data-tooltip={`Edit your ad`}
                                />
                                {pin.type !== LIVE_MUSIC ?
                                    <SVGInline
                                        onClick={()=>bouncePin(pin)}
                                        svg={bounceSVG}
                                        component="i"
                                        data-tooltip={`Bounce your ad to the top`}
                                        className="tooltip-lg"
                                    /> : null
                                }
                                <SVGInline
                                    onClick={()=>removePin(pin)}
                                    svg={trashSVG}
                                    component="i"
                                    className="delete tooltip-md"
                                    data-tooltip={`Delete your ad`}
                                />
                            </div>

                            {/*<div className="pin-status">*/}
                            {/*{pin.isOnHold ? <span className={getClassName(pin)}>ON HOLD</span> : null}*/}
                            {/*{!pin.subscription.isPayed ? <span className="not-payed">NOT PAYED</span> : null}*/}

                            {/*</div>*/}
                            <div className="separator top" />
                            <div className="separator bottom" />

                            <div className="package-container">
                                {renderHeroSelection(pin, enrolType)}
                                {renderUpgradeBtn(pin, enrolType)}
                                <div className="arrow-wrapper rtl">
                                    {renderArrow(pin)}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            )
        });
    }

    const renderPinRowMobile = pins => {
        if (!pins || !pins.length) return null;

        // מודעה בסיסית
        // מודעת Push
        // מודעת Rule
        // מודעת Huge

        return pins.map((pin, index) => {
            if (!pin || !pin.subscription) return null;

            const enrolType = pin.subscription.upgrade || pin.subscription.enrolType;

            let enrolLabel = 'מודעה בסיסית'
            switch(enrolType) {
                case ENROL_TYPE_MEDIUM: enrolLabel = 'מודעת Push'
                    break
                case ENROL_TYPE_HIGH: enrolLabel = 'מודעת Rule'
                    break
                case ENROL_TYPE_HUGE: enrolLabel = 'מודעת Hero'
            }

            return (
                <div key={`pin-row-${index}`} className="pin-row-mobile">
                    <div className={`enrol-label-container ${enrolType}`}>
                        {enrolType === ENROL_TYPE_HUGE ? <SVGInline className="icon-huge-lightning" svg={lightningSlickSVG} component="i" /> : null}
                        <span className="enrol-label">{enrolLabel}</span>
                        {enrolType === ENROL_TYPE_HUGE ? <SVGInline className="icon-huge-lightning" svg={lightningSlickSVG} component="i" /> : null}
                    </div>

                    <div className="name-btns-container">
                        <div className="name-icon">
                            <div className="icon" style={{backgroundImage: 'url(' + getCategoriesImage(pin) + ')' }}>
                                {type.name === BAND || type.name === MUSICIAN
                                    ?
                                    <SVGInline svg={smallStarSVG} component="i" className="small-start"/>
                                    : null
                                }
                            </div>
                            <div className="pin-name">{pin.name.length > titleLetters ? pin.name.substring(0, 25) + '...' : pin.name}</div>
                        </div>
                        <div className="options">
                            <SVGInline
                                onClick={()=>editPin(pin)}
                                svg={editSVG}
                                component="i"
                                className="edit tooltip-md"
                                data-tooltip={`Edit your ad`}
                            />
                            {pin.type !== LIVE_MUSIC ?
                                <SVGInline
                                    onClick={()=>bouncePin(pin)}
                                    svg={bounceSVG}
                                    component="i"
                                    data-tooltip={`Bounce your ad to the top`}
                                    className="tooltip-lg"
                                /> : null
                            }
                            <SVGInline
                                onClick={()=>removePin(pin)}
                                svg={trashSVG}
                                component="i"
                                className="delete tooltip-md"
                                data-tooltip={`Delete your ad`}
                            />
                        </div>
                    </div>

                    <div className="location-status-container">
                        <div className="location-container">
                            <SVGInline svg={locationSVG()} component="i" width="21px" height="21px" className="locationIcon"/>
                            <div className="location">{renderLocation(pin.location)}</div>
                            {/*<div className="location-sub-title">{renderSubLocation(pin.location)}</div>*/}
                        </div>
                        {renderStatus(pin)}
                        {renderHeroSelection(pin, enrolType)}
                    </div>

                    <div className="upgrade-btn-container">
                        {renderUpgradeBtn(pin, enrolType)}
                    </div>
                </div>
            )
        })
    }

    const titleLetters = 25;

    return (
        <div className="pins-list rtl">
            <div className={"top-stripe " + type.name}>
                <div className="text">
                    {type.name === BAND || type.name === MUSICIAN
                        ?
                        <div className={`band-finder-icon-wrapper ${type.name === BAND ? BAND : MUSICIAN}`}>
                            <SVGInline svg={scopWhiteSVG} component="i" className="band-finder-icon" />
                        </div>
                        : null
                    }
                     יש לך  ({pins.length}) {type.plural}
                </div>
            </div>

            {isMobile() ? renderPinRowMobile(pins) : renderPinRowWeb(pins)}

            {pins && pins.length ?
                <div className="add-row">
                    <div className="row-content" onClick={() => newPin(type.name)}>
                        <div className="plus">+</div>
                        <div className="text">
                        הוספת {type.singular}
                     </div>
                    </div>
                </div>
                :
                <div className="no-pins">
                    <SVGInline svg={sleepingMugicsSVG} component="i" width="130px"/>
                    <div className="text">
                        אין לך {type.plural} כרגע!
                    </div>
                    <div className="add-new">
                        <div className="plus" onClick={()=>newPin(type.name)}>+</div>
                    </div>
                </div>
            }
        </div>
    )
};

PinsList.propTypes = {
    type: PropTypes.object,
    pins: PropTypes.array,
    editPin: PropTypes.func,
    duplicatePin: PropTypes.func,
    removePin: PropTypes.func,
    newPin: PropTypes.func,
    bouncePin: PropTypes.func,
    datatypes: PropTypes.object,
    isTempUser: PropTypes.bool,
    selectEnroll: PropTypes.func,
    handleHeroAdToggle: PropTypes.func
};

export default PinsList;



// WEBPACK FOOTER //
// ./src/Components/Users/PinsList.js